import { ReactNode, useMemo } from 'react'
import cn from 'classnames'
import Mirror from 'src/icons/mirror.webp'

import { useLocalizedText } from 'src/shared/utils/use-localized-text/useLocalizedText'

import { texts } from './text-fourth-step'
import { Button } from 'src/shared/ui/lib/button/Button'
import { useControlModal, ModalType } from '@rockstar/registration-component'
import { SignUp } from 'src/features/registration/SignUp'

import { textBtn } from './mock'
import { TLang } from 'src/constants/langs'
import cls from './styles.module.scss'

type TProps = {
    lang: TLang
}

export const FourthStep = ({ lang }: TProps) => {
    const { modalType, setModalType } = useControlModal()
    const { content } = useLocalizedText(lang, texts)

    const isSecondGroupLang =
        lang === 'fr' ||
        lang === 'it' ||
        lang === 'pt' ||
        lang === 'el' ||
        lang === 'sl'

    const MODALS = useMemo<{ [key in ModalType]: ReactNode | null }>(
        () => ({
            sign_up: <SignUp language={lang} />,
            clear: null,
        }),
        [lang],
    )

    const getBtnTextByLang = () =>
        textBtn.find((item) => item.lang === lang)?.text ?? ''

    return (
        <div className={cn(cls.root, cls.hello)}>
            <div
                className={cls.mirror}
                style={{ backgroundImage: `url(${Mirror})` }}
            >
                <div className={cls.container}>{content}</div>
                <Button
                    value={getBtnTextByLang()}
                    mode="primary"
                    className={cn(cls.button, {
                        [cls[`button--second_group_lang`]]: isSecondGroupLang,
                        [cls[`button--el`]]: lang === 'el',
                    })}
                    onClick={() => setModalType('sign_up')}
                />
            </div>
            {MODALS[modalType]}
        </div>
    )
}
